import { useEffect } from "react";

import "bootstrap/dist/js/bootstrap.bundle.min";

import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/style.scss";

//routes
import Routes from "./routes/Routes";

import AOS from "aos";

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return <Routes />;
}

export default App;
